import { LOGOUT } from '../constants/auth';
import { POST_SETTINGS_SUCCESS, POST_SETTINGS_FAIL, GET_SETTINGS_SUCCESS, GET_SETTINGS_FAIL, SETTINGS_PANEL, CLOSE_PANEL, SOUND_SETTINGS_PANEL, SET_INPUT_DEVICE, SET_OUTPUT_DEVICE, SETTINGS_MENU_OPEN, MODAL_STATE } from '../constants/buddyBooks';

const initialState = {
    data: null,
    isError: false,
    panel: {
        isPanelClosing: false,
        soundSettingsPanel: false,
        settingsPanel: false,
        searchPanel: false
    },
    soundDevices: {
        input: "",
        output: ""
    },
    modalState: {
        isModalOpen: false,
        isQuestionClicked: false
    },
    isSettingsMenuOpen: false
}

export default function settings(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case POST_SETTINGS_SUCCESS:
            return state;
        case POST_SETTINGS_FAIL:
            return {
                ...state,
                isError: true
            };
        case GET_SETTINGS_SUCCESS:
            return {
                ...state,
                data: payload,
                isError: false
            };
        case GET_SETTINGS_FAIL:
            return {
                ...state,
                isError: true
            };
        case SETTINGS_PANEL:
            return {
                ...state,
                panel: {
                    ...state.panel,
                    isPanelClosing: payload
                }
            };
        case CLOSE_PANEL:
            return {
                ...state,
                panel: {
                    ...state.panel,
                    settingsPanel: action.settingsPanel,
                    searchPanel: action.searchPanel
                }
            };
        case SOUND_SETTINGS_PANEL:
            return {
                ...state,
                panel: {
                    ...state.panel,
                    soundSettingsPanel: payload
                }
            };
        case SET_INPUT_DEVICE:
            return {
                ...state,
                soundDevices: {
                    ...state.soundDevices,
                    input: payload
                }
            };
        case SET_OUTPUT_DEVICE:
            return {
                ...state,
                soundDevices: {
                    ...state.soundDevices,
                    output: payload
                }
            };
        case SETTINGS_MENU_OPEN:
            return {
                ...state,
                isSettingsMenuOpen: action.isSettingsMenuOpen
            };
        case MODAL_STATE:
            return {
                ...state,
                modalState: {
                    isModalOpen: action.isModalOpen,
                    isQuestionClicked: action.isQuestionClicked
                }
            };
        case LOGOUT:
            return {
                ...state,
                data: null,
                isError: true
            };
        default:
            return state;
    }
}